import React, { useState } from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { SignOutButton } from "../SignOutButton";
import { useUserPreferences } from "../../context/UserPreferencesContext";
import { AshleyVoiceSettingsSection } from "./AshleyVoiceSettingsSection";
import { AppearanceSettingsSection } from "./AppearanceSettingsSection";
import { ConnectedServicesSection } from "./ConnectedServicesSection";
import { isConnectedServicesUiEnabled } from "../../connectedServices/connectedServicesGate";
import { AboutLegalSection } from "./AboutLegalSection";
import { useIsDesktopViewport } from "../../hooks/useIsDesktopViewport";
import "../admin/adminDesktop.css";
import "./UserPreferencesScreen.css";


export function UserPreferencesScreen({ onBack, onSignOut }) {
  const { preferences, updatePreferences, error } = useUserPreferences();
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const isDesktop = useIsDesktopViewport();

  const handleUpdatePreferences = async (patch) => {
    setSaving(true);
    try {
      await updatePreferences(patch);
      setSaved(true);
      window.setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  if (isDesktop) {
    return (
      <CrewPilotModuleShell
        title="Preferences"
        subtitle="Personal settings for your CrewPilot account"
        sectionLabel="Settings"
        onBack={onBack}
        headerActions={<SignOutButton onClick={onSignOut} />}
        layout={PAGE_LAYOUT.COMMAND}
      >
        <div className="adm-scope">
          {error ? (
            <p className="admin-placeholder-note" style={{ marginBottom: "12px" }}>
              Cloud sync unavailable. Changes are saved on this device until you are back online.
            </p>
          ) : null}
          <div className="adm-split">
            <div className="rb-card user-preferences adm-settings__panel">
              <div className="section-heading">Appearance</div>
              <AppearanceSettingsSection
                preferences={preferences}
                onUpdatePreferences={handleUpdatePreferences}
                saving={saving}
              />
            </div>
            <div className="rb-card user-preferences adm-settings__panel">
              <div className="section-heading">Ashley</div>
              <AshleyVoiceSettingsSection
                preferences={preferences}
                onUpdatePreferences={handleUpdatePreferences}
                saving={saving}
              />
            </div>
            {isConnectedServicesUiEnabled() ? (
              <div className="rb-card user-preferences adm-settings__panel">
                <div className="section-heading">Connected Services</div>
                <ConnectedServicesSection />
              </div>
            ) : null}
            <div className="rb-card user-preferences adm-settings__panel">
              <div className="section-heading">About & Legal</div>
              <AboutLegalSection />
            </div>
          </div>
          {saved ? (
            <p className="admin-save-confirmation" role="status" style={{ marginTop: "12px" }}>
              Preferences updated.
            </p>
          ) : null}
        </div>
      </CrewPilotModuleShell>
    );
  }

  return (
    <CrewPilotModuleShell
      title="Preferences"
      subtitle="Personal settings for your CrewPilot account"
      sectionLabel="Settings"
      onBack={onBack}
      headerActions={<SignOutButton onClick={onSignOut} />}
      layout={PAGE_LAYOUT.FORM}
    >
      <div className="rb-card user-preferences">
        {error ? (
          <p className="admin-placeholder-note" style={{ marginBottom: "12px" }}>
            Cloud sync unavailable. Changes are saved on this device until you are back online.
          </p>
        ) : null}

        <AppearanceSettingsSection
          preferences={preferences}
          onUpdatePreferences={handleUpdatePreferences}
          saving={saving}
        />

        <AshleyVoiceSettingsSection
          preferences={preferences}
          onUpdatePreferences={handleUpdatePreferences}
          saving={saving}
        />

        {isConnectedServicesUiEnabled() ? <ConnectedServicesSection /> : null}

        {saved ? (
          <p className="admin-save-confirmation" role="status">
            Preferences updated.
          </p>
        ) : null}

        <AboutLegalSection />

      </div>
    </CrewPilotModuleShell>
  );
}
